// @ts-nocheck
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, Icon, Box, Typography } from '@material-ui/core';
import { StringUtils } from '../utils';
import { ReactComponent as EmptyImage } from '../../assets/empty.svg';
import { ReactComponent as UnavailableImage } from '../../assets/unavailable.svg';
import { ReactComponent as ErrorImage } from '../../assets/error.svg';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(6),
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  center: {
    height: '100%',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: '192px',
    height: '192px',
    marginTop: theme.spacing(3),
  },
  icon: {
    marginTop: '-1px',
    marginBottom: '3px',
  },
  message: {
    display: 'flex',
    marginTop: theme.spacing(1),
  },
}));

function EmptyState(props) {
  const classes = useStyles();

  const { id, center, message, variant } = props;

  const getImage = () => {
    let Component = null;
    switch (variant) {
      case 'empty':
        Component = EmptyImage;
        break;
      case 'unavailable':
        Component = UnavailableImage;
        break;
      case 'error':
        Component = ErrorImage;
        break;
      default:
        break;
    }
    if (!Component) {
      return null;
    }
    return (
      <Box className={classes.flex}>
        <Component id={StringUtils.makeId(id, 'image')} className={classes.image} />
      </Box>
    );
  };

  return (
    <Box
      id={StringUtils.makeId(id, 'container')}
      className={clsx(classes.container, { [classes.center]: center })}
    >
      {getImage()}
      <Typography id={StringUtils.makeId(id, 'message')} className={classes.message}>
        <Icon className={classes.icon}>info</Icon>
        &nbsp;
        {message}
      </Typography>
    </Box>
  );
}

EmptyState.defaultProps = {
  id: undefined,
  center: true,
  variant: 'default',
};

EmptyState.propTypes = {
  id: PropTypes.string,
  center: PropTypes.bool,
  message: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'empty', 'unavailable', 'error']),
};

export default EmptyState;
